import { useSelector } from "react-redux";
import { MODULE_KEY } from "./action";
import { ACTION } from "../../util/utils";
import { formatDate } from "src/util/date";

export default function filterColumns() {
  const { data, loading } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );
  const vendors: any | null | undefined = [];
  data?.map((row: any) => {
    vendors.push({ text: row.VendorName, value: row.VendorName });
  });

  let vendorName = vendors.filter(
    (ele: any, ind: any) =>
      ind === vendors.findIndex((elem: any) => elem.text === ele.text)
  );

  return { data, loading, vendorName };
}
